import { render } from "./DialogNotExistSeat.vue?vue&type=template&id=08de20b9"
import script from "./DialogNotExistSeat.vue?vue&type=script&lang=js"
export * from "./DialogNotExistSeat.vue?vue&type=script&lang=js"
script.render = render

export default script